var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 specific-skeleton-card"},[_c('b-skeleton',{attrs:{"height":"400px","width":"100%","animated":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }